/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaDTO
 */
export interface EmergenzaDTO {
    /**
     * 
     * @type {string}
     * @memberof EmergenzaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaDTO
     */
    nome?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaDTO
     */
    dataFine?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the EmergenzaDTO interface.
 */
export function instanceOfEmergenzaDTO(value: object): value is EmergenzaDTO {
    return true;
}

export function EmergenzaDTOFromJSON(json: any): EmergenzaDTO {
    return EmergenzaDTOFromJSONTyped(json, false);
}

export function EmergenzaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'dataFine': json['dataFine'] == null ? undefined : (new Date(json['dataFine'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function EmergenzaDTOToJSON(value?: EmergenzaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio']).toISOString()),
        'dataFine': value['dataFine'] == null ? undefined : ((value['dataFine'] as any).toISOString()),
        'note': value['note'],
    };
}

